import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import React from 'react';

import type { PlanType } from '@constants/plans';

interface PlanCardProps {
  /** Callback that fires when the plan card is clicked */
  onClick?: (planType: PlanType) => void;
  imageSrc: string;
  title: string;
  description: string[];
  planType: PlanType;
  price: string;
}

const PlanCard = ({
  onClick,
  imageSrc,
  title,
  description,
  planType,
  price,
}: PlanCardProps) => {
  const handleClick = () => {
    onClick?.(planType);
  };
  return (
    <Card sx={{ width: '100%', maxWidth: '333px' }}>
      <CardActionArea onClick={handleClick}>
        <CardHeader
          title={title}
          slotProps={{
            title: {
              typography: {
                variant: 'overline',
                fontSize: 16,
                textAlign: 'center',
              },
            },
            subheader: {
              textAlign: 'center',
            },
          }}
          subheader={price}
        />
        <CardMedia
          component="img"
          width="50%"
          image={imageSrc}
          alt="plan img"
          sx={{ margin: '0 auto', width: '67%' }}
        />
        <CardContent>
          <List>
            {description.map((text, index) => (
              <ListItem key={`plan-description-${index}`}>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PlanCard;
